<div>
  <footer fxLayout="row" [ngClass]="{'env':!envMessage, 'envOverride':envMessage}">
    <mat-icon svgIcon="cad-logo"></mat-icon>
    <div fxFlex></div>
    <button mat-button>v{{ configService?.version }}</button>
  </footer>
</div>
